import { Workspace } from '@repo/api-client';
import { H7 } from '@repo/ui-kit/components/core/Typography';

type WorkspaceMemberCountProps = {
  memberCount: Workspace['memberCount'];
};

export const WorkspaceMemberCount: React.FC<WorkspaceMemberCountProps> = ({
  memberCount,
}) => {
  return (
    <H7 color="secondary">
      {memberCount} member{memberCount && memberCount > 1 ? 's' : ''}
    </H7>
  );
};
